module.exports = __webpack_public_path__ + "static/media/homepage-auto-generate.218d9a58.webm";